import React from "react";
import { AppWrap, MotionWrap } from '../../wrapper';
import {FcIdea} from 'react-icons/fc';
import {RiLightbulbFlashFill} from 'react-icons/ri';
import {FaMedal,FaPoll,FaLightbulb} from 'react-icons/fa';

const Form = () =>  {
  return (
    <>
    
      <main className='bg-blue-100'   >
     
     <section className="grid  gap-4  justify-items-center  justify-center items-center   space-y-12 space-x-4  ">
     <div className="flex  flex-wrap text-center justify-center">
              <div className=" w-full lg:w-6/12 px-4">
                <h2 className="text-4xl font-semibold text-blue-900 ">
                what you can do with Data
                </h2>
                <p className="text-lg leading-relaxed mt-4 mb-4 text-gray-500">
                When you trust your data and act decisively, 
                you will gain a distinct competitive advantage that will have a direct impact on your company’s performance.                </p>
              </div>
            </div>

          <div className="mt-0 mx-auto px-4 lg:pt-24 lg:pb-64"  data-aos='fade-in'>
            
            <div className="flex flex-wrap  justify-center   ">
            <div className="w-full lg:w-3/12 px-4 text-center space-y-4 mb-4">
                <div className="text-gray-900 p-2 w-12 h-12 shadow-lg rounded-full bg-blue-500 inline-flex items-center justify-center">
                 <RiLightbulbFlashFill className="text-xl text-white"  />
                </div>
                <h5 className="text-xl mt-5 font-semibold text-blue-600">
                Make Faster, Smarter Decisions
                </h5>
                <p className="mt-2 mb-4 md:mb-4  lg:mb-4 text-gray-600">
                Real-time data has become a major selling point of many big data programs, and for good reason.
                 With live insights, you can go beyond simply analyzing past trends. 
                </p>
              </div>
              <div className="w-full lg:w-3/12 px-4 text-center">
                <div className="text-whit p-3 w-12 h-12 shadow-lg rounded-full bg-blue-500 inline-flex items-center justify-center">
                  <FaMedal className="fas fa-medal text-xl text-white" />
                </div>
                <h6 className="text-xl mt-5 font-semibold text-blue-600 ">
                Use Data For Smarter Business Planning
                </h6>
                <p className="mt-2 mb-4 md:mb-4  lg:mb-4 text-gray-500 ">
                Your data can have a profound impact on almost every area of your business. Of course, your data will only be useful if you are able to interpret what the numbers mean for your brand and you are willing to act on those insights.
                </p>
              </div>
              <div className="w-full lg:w-3/12 px-4 text-center">
                <div className="text-gray-900 p-3 w-12 h-12 shadow-lg rounded-full bg-blue-500 inline-flex items-center justify-center">
                  
                  <FaPoll className="fas fa-poll text-xl text-white"  />
                </div>
                <h5 className="text-xl mt-5 font-semibold text-blue-600  ">
                  Grow your market Share
                </h5>
                <p className="mt-2 mb-4 md:mb-32 sm:mb-32   lg:mb-32 xl:mb-6 text-gray-500">
                  Some quick example text to build on the card title and make up
                  the bulk of the card's content.
                </p>
              </div>
              
            </div>
          </div>
        </section>
        

        <section id="contact" className="relative block sm:pt-20 py-24 lg:pt-0 ">
          <div className="container mx-auto px-4">
            <div className="flex flex-wrap justify-center lg:-mt-64 -mt-48">
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-300">
                  <div className="flex-auto opacity-4 p-5 lg:p-10 bg-blue-400 hover:shadow-lg " >
                    <h4 className="text-3xl text-white font-bold">
                      Get in Touch
                    </h4>
                    <p className="leading-relaxed  mt-1 mb-4 text-gray-800">
                      Complete this form and i will get back to you in 24 hours.
                    </p>
                    <form name="contact" action="/pages/success" method="POST" data-netlify="true">

                   
                      <label
                        className="block uppercase text-white text-xs font-bold mb-2"
                      for="name"
                      >
                        Full Name
                      </label>
                      <input
                        type="text"
                        name="name" id="name"
                        className="border-0 px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
                        placeholder="Full Name"
                        style={{ transition: "all .15s ease" }}
                      />
       
         
                      <label
                        className="block uppercase text-white text-xs font-bold mb-2"
                        for="email"
                      >
                        Email
                      </label>
                      <input
                       type="email" name="email" id="email"
                        className="border-0 px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
                        placeholder="Email"
                        style={{ transition: "all .15s ease" }}
                      />
                

                
                      <label
                        className="block uppercase text-white text-xs font-bold mb-2"
                        for="message"
                      >
                        Message
                      </label>
                      <textarea
                      name="comments" id="comments"
                        rows="4"
                        cols="80"
                        className="border-0 px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
                        placeholder="Type a message..."
                      />
           
           
                      
                      <button
                     
                        className="bg-blue-500 text-white active:bg-blue-700 hover:bg-blue-800 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1"
                        type="submit"
                        style={{ transition: "all .17s ease" }}
                      >
                        
                     
                        Send Message
                        
                      </button>
                     
                   
           
          </form>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
  
        </section>
    
      </main>
 
    </>
  );
}
export default AppWrap(
  MotionWrap(Form, 'flex-1 w-full flex-col'),
  'Form',
  'bg-blue-100',
);